import { Router } from "vue-router";

export function createTitleGuard(router: Router) {
  router.afterEach(async (to) => {
    if (to.meta?.title) {
      document.title = `${to.meta.title}-${import.meta.env.VITE_NAME}`;
    } else {
      document.title = import.meta.env.VITE_NAME;
    }
    return true;
  });
}
